import { styled } from 'styled-components'

export const Container = styled.div<{ $isPassThrough: boolean }>`
  pointer-events: ${({ $isPassThrough }) => ($isPassThrough ? 'none' : 'all')};
  width: fit-content;
  margin: auto;
`
